<template>
  <timeline 
    @remove-interaction="$emit('remove-interaction', $event)"
    @scheduled-interaction-realized="$emit('scheduled-interaction-realized', $event)"
  >
  </timeline>
</template>
<script>
import Timeline from "./Timeline"

export default {
  name:"CRM_Lead_Interaction_List",
  components:{
    Timeline,
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// client/components/CRM/Interactions/List.vue